import React from 'react';
import { DynamicField, DynamicFieldTypes } from 'src/components/dynamic-widget';
import DynamicFormWidget from 'src/components/dynamic-widget/DynamicFormWidget';
import { DataService } from 'src/services/data-service';
import GenericDialog from 'src/components/GenericDialog';
import { useAppDispatch } from 'src/redux/hooks';
import { showAlert } from 'src/redux/alert/alertReducer';
import { IEmbassyMessage, IUpdateEmbassyMessageModel } from '.';

interface IUpdateEmbassyMessageProps {
  onSuccess: () => void;
  onClose: () => void;
  message: IEmbassyMessage;
}

const languages = {
  en: 'English',
  ar: 'Arabic',
  fr: 'French',
};

const UpdateEmbassyMessage: React.FC<IUpdateEmbassyMessageProps> = ({ onSuccess, onClose, message }) => {
  const dispatch = useAppDispatch();

  const formConfig = React.useMemo((): Record<string, DynamicFieldTypes> => ({
    title: {
      type: DynamicField.TEXT,
      required: true,
      name: 'title',
      title: 'Title',
      value: message.title,
      disabled: false
    },
    description: {
      type: DynamicField.TEXTAREA,
      required: true,
      name: 'description',
      title: 'Description',
      value: message.description,
      disabled: false
    },
    language: {
      type: DynamicField.SELECT,
      required: true,
      name: 'language',
      title: 'Language',
      value: message.language,
      disabled: false,
      items: languages
    }
  }), [message]);

  const submit = React.useCallback(async (data: Record<string, any>) => {
    const payload: IUpdateEmbassyMessageModel = {
      id: message.id,
      ...data
    };

    const response = await DataService.post(
      'api/EmbassyMessage/update',
      payload,
      undefined
    );

    if (response.ok) {
      onSuccess();
      return true;
    } else {
      const result: { message: string } = await response.json();
      dispatch(showAlert({
        message: result.message || 'An error occurred!',
        type: 'error'
      }));
      return false;
    }
  }, [dispatch, onSuccess, message.id]);

  return (
    <GenericDialog
      open={true}
      title="Edit Embassy Message"
      onClose={onClose}
    >
      <DynamicFormWidget
        title=""
        fields={formConfig}
        onSubmit={submit}
      />
    </GenericDialog>
  );
};

export default UpdateEmbassyMessage;
